import { DateInput } from "@/components/admin/date-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";

import { leadFormTypes, leadStatusChoices } from "../contacts/leadModel";
import { FreeTextAutocompleteInput } from "./FreeTextAutocompleteInput";

// Bounds are built from the user's local day, matching the local-time Date column.
const startOfDay = (value: string) =>
  value ? new Date(`${value}T00:00:00`).toISOString() : value;
const endOfDay = (value: string) =>
  value ? new Date(`${value}T23:59:59.999`).toISOString() : value;

/**
 * Filter inputs of the Leads list. Keys follow the `field@operator`
 * convention supported by both the Supabase and FakeRest providers.
 */
export const leadListFilters = [
  <SelectInput
    key="form_type"
    source="form_type@eq"
    label="resources.lead_submissions.fields.form_type"
    choices={leadFormTypes.map((id) => ({ id, name: id }))}
    translateChoice={false}
    helperText={false}
    alwaysOn
  />,
  <SelectInput
    key="status"
    source="contact_status@eq"
    label="resources.lead_submissions.fields.contact_status"
    choices={leadStatusChoices.map(({ value, label }) => ({
      id: value,
      name: label,
    }))}
    translateChoice={false}
    helperText={false}
    alwaysOn
  />,
  <ReferenceInput key="sales" source="sales_id@eq" reference="sales" alwaysOn>
    <SelectInput
      label="resources.lead_submissions.fields.sales_id"
      optionText={(sale) => `${sale.first_name} ${sale.last_name}`}
      helperText={false}
    />
  </ReferenceInput>,
  <DateInput
    key="from"
    source="submitted_at@gte"
    label="resources.lead_submissions.filters.date_from"
    parse={startOfDay}
    helperText={false}
    alwaysOn
  />,
  <DateInput
    key="to"
    source="submitted_at@lte"
    label="resources.lead_submissions.filters.date_to"
    parse={endOfDay}
    helperText={false}
    alwaysOn
  />,
  <FreeTextAutocompleteInput
    key="utm"
    source="utm_source@eq"
    label="resources.lead_submissions.fields.utm_source"
    valuesResource="lead_submissions"
    valuesField="utm_source"
    alwaysOn
  />,
];
